import { render, staticRenderFns } from "./TransferReportFilterTabs.vue?vue&type=template&id=377d359a&"
import script from "./TransferReportFilterTabs.vue?vue&type=script&lang=js&"
export * from "./TransferReportFilterTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports